export default {
  data() {
    return {
      categoryId: null,
      categoryName: null,
      groups: [],
      step: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    categories() {
      return this.$store.state.news.categories;
    },
    docs() {
      return this.$store.state.news.docs;
    },
  },
  methods: {
    getPublicationCat(id) {
      this.categoryId = id;
      const cat = this.categories.filter(item => item.id === this.categoryId);
      this.groups = cat[0].groups;
      this.step = 1;
    },
    getPublicationGroup(id, name) {
      this.step = 1;
      this.categoryName = name;
      this.$store.dispatch('news/GetDocs', {
        profile_id: this.user.profile_id,
        category_id: id,
      });
    },
    getPublication(id) {
      this.$store.dispatch('news/GetDoc', id);
      this.$router.push(`/doc/${id}`);
    },
    decStep() {
      this.step = this.step - 1;
      this.step = this.step > 0 ? this.step : 0;
    },
  },
  created() {
    this.user.profile_id && this.$store.dispatch('news/GetCategoryDocs', this.user.profile_id);
  },
};
